<template>
    <v-sheet
        flat
        outlined
        v-ripple
        hover
        rounded="lg"
        class="d-flex align-center pa-3"
        height="100%"
    >
        <div class="me-4">
            <v-icon size="60" :color="iconColor">{{icon}}</v-icon>
        </div>
            <div>
                <div class="font-weight-bold">{{title}}</div>
                <slot name="value" v-bind="{value}">
                    <div class="text-h3">{{millify(value)}}</div>
                </slot>
            </div>
    </v-sheet>
</template>

<script>
import millify from 'millify';

export default {
    props: {
        icon: String,
        title: String,
        value: Number,
        iconColor: String
    },
    methods: {
        millify
    }
}
</script>

<style>

</style>